import { render, staticRenderFns } from "./CmgLoyaltyProgressWalletStickyHeader.vue?vue&type=template&id=9d72a63c&scoped=true&lang=pug"
import script from "./cmg-loyalty-progress-wallet-sticky-header.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-progress-wallet-sticky-header.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyProgressWalletStickyHeader.vue?vue&type=style&index=0&id=9d72a63c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d72a63c",
  null
  
)

export default component.exports